import React, { useState, useEffect, useContext, useCallback } from "react";
import { Button, Table, Space, Dropdown, notification, Input, Select } from "antd";
import { DeleteOutlined, EditOutlined, DownOutlined, SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import TemplateForm from "../components/Forms/TemplateForm";
import axios from "axios";
import "moment-timezone";
import GlobalContext from "../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import MessageDialog from "../components/MessageDialog";
import LoadingModal from "../utils/LoadingModal";
import { useNavigate } from 'react-router-dom';

// import formatTimestamp from "../utils/FormatTimestamp";
import { Link } from "react-router-dom";


const PAGE_SIZE = 15;
const { Option } = Select;

const TemplateTable = () => {
  const navigate = useNavigate();
  const globals = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentTemplate, setCurrentDepto] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });
  const [messageVisible, setMessageVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [departments, setDepartments] = useState([]);
  const [departmentsId, setDepartmentsId] = useState(null);
  const [meeting_types, setMeetingTypes] = useState([]);
  const [meetingTypesId, setMeetingTypesId] = useState(null);

  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   key: "id",
    //   width: 50,
    // },
    {
      title: "Nombre de la plantilla",
      dataIndex: "name",
      key: "name",
      width: 300,
      render: (_, record) => {
        //navigate to template detail
        return (
          <Link to={`/template/${record.id}`}>{record.name}</Link>
        )
      }
    },
    {
      title: "Departamento",
      dataIndex: ["department", "name"],
      key: "department",
    },
    {
      title: "Tipo de reunión",
      dataIndex: ["meeting_type", "name"],
      key: "meeting_type",
    },
    // {
    //   title: "Invitados",
    //   dataIndex: "guests",
    //   key: "guests",
    //   render: (_, record) => {
    //     if (record.guests === null || record.guests === "") {
    //       return (
    //         <Button type="link">Sin invitados</Button>
    //       )
    //     }
    //     const guestList = record.guests.split(',');
    //     const g = guestList.map((guest, index) => {
    //       return <div key={index}>{guest}</div>
    //     })
    //     return (
    //     <Tooltip title={g}>
    //       <Button type="link">{`${guestList.length} `}{(guestList.length > 1) ? `personas` : `persona`}</Button>
    //     </Tooltip>
    //     )
    //   },
    // },
    {
      title: "Opciones",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            trigger={["click"]}
            menu={{
              items:[
                {
                  key: '1',
                  label: 'Ver puntos',
                  icon:<UnorderedListOutlined />,
                  onClick: () => handleActionClick("points", record)
                },
                {
                  key: '2',
                  label: 'Editar',
                  icon:<EditOutlined />,
                  onClick: () => handleActionClick("edit", record)
                },
                {
                  key: '3',
                  label: 'Eliminar',
                  icon:<DeleteOutlined />,
                  onClick: () => handleActionClick("delete", record)
                },
              ],
            }}
          >
            <Button icon={<DownOutlined />} shape="circle" />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const fetchMeetingTypes = useCallback(async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-meeting-types`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setMeetingTypes(response?.data?.data);
    } catch (error) {
      console.error("Error fetching meeting types", error.response);
      notification.error({
        message: "Error obteniendo tipos de reunión",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchDepartments = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-departments`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setDepartments(response?.data?.data);
    } catch (error) {
      console.error("Error fetching departments:", error.response);
      notification.error({
        message: "Error obteniendo departamentos",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchData = useCallback(
    async (newPagination, search, meetingTypesId, departmentsId) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-templates`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              search: search,
              meetingTypesId,
              departmentsId,
            },
          }
        );
        setData(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          }
          );
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error.response.data.status != -2){
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
        else{
          notification.success({
            message: "Información obtenida exitosamente!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchMeetingTypes();
    fetchDepartments();
    fetchData(null, null, null, null);
  }, [fetchData, fetchMeetingTypes, fetchDepartments]);

  const handleActionClick = async (key, record) => {
    if (key === "edit") {
      setIsEdit(true);
      setCurrentDepto(record);
      setShowTemplateForm(true);
    }
    else if (key === "delete") {
      setCurrentDepto(record);
      setMessageVisible(true);
    }
    else if (key === "points") {
      navigate(`/template/${record.id}`);
    }
  };

  async function handleTableChange(newPagination) {
    fetchData(newPagination, searchText, meetingTypesId, departmentsId);
  }

  const saveTemplateForm = async ({status, newTemplate}) => {
    setShowTemplateForm(false);
    if (isEdit) {
      setIsEdit(false);
      notification.success({
        message: "Plantilla editada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    if(status === "created"){
      setData([newTemplate, ...data]);
    }

    notification.success({
      message: "Plantilla creada exitosamente!",
      placement: "bottomRight",
      duration: 2,
    });
  };

  const closeTemplateForm = () => {
    setShowTemplateForm(false);
    setIsEdit(false);
    setCurrentDepto(null);
  };

  const deleteTemplate = async () => {
    setMessageVisible(false);
    try{
      await axios.delete(`${globals.SERVICE_API_DB}/v1/delete-template/${currentTemplate.id}`,
      {
        headers: {
          "x-token": globals.token,
        },
      });
      setData(data.filter((item) => item.id !== currentTemplate.id));
      notification.success({
        message: "Plantilla eliminada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    }
    catch(err){
      console.log(err.response.data);
      notification.error({
        message: "Error eliminando plantilla",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
  };

  const handleRefresh = () => {
    fetchData(null, searchText, meetingTypesId, departmentsId);
  };

  const handleSearch = async () => {
    fetchData(null, searchText, meetingTypesId, departmentsId);
  };

  const handleSearchEnterKey = async (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const filterMeetingTypeOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  const filterDepartmentsOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h2 style={{ marginRight: "16px" }}>Plantillas</h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          onClick={() => {
            setIsEdit(false);
            setShowTemplateForm(true);
          }}
          style={{ marginRight: "8px" }}
        >
          Crear
        </Button>
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <Input
        placeholder="Ingresa un nombre"
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16, width: 200 }}
        prefix={<SearchOutlined />}
        onKeyDown={handleSearchEnterKey}
      />
      <Select
        allowClear
        style={{ width: 200, marginLeft: 8 }}
        showSearch
        value={departmentsId}
        onChange={(value) => setDepartmentsId(value)}
        placeholder="Departamentos"
        filterOption={filterDepartmentsOption}
        optionFilterProp="children"
      >
        {departments.map((option) => (
          <Option key={option.id} value={option.id}>
            {option.name}
          </Option>
        ))}
      </Select>
      <Select
        allowClear
        style={{ width: 200, marginLeft: 8, marginRight: 8 }}
        showSearch
        value={meetingTypesId}
        onChange={(value) => setMeetingTypesId(value)}
        placeholder="Tipo de reunión"
        filterOption={filterMeetingTypeOption}
        optionFilterProp="children"
      >
        {meeting_types.map((option) => (
          <Option key={option.id} value={option.id}>
            {option.name}
          </Option>
        ))}
      </Select>
      <Button onClick={handleSearch} style={{ marginRight: "8px" }}>
        Buscar
      </Button>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />

      <TemplateForm
        open={showTemplateForm}
        onFinish={saveTemplateForm}
        onCancel={closeTemplateForm}
        isEdit={isEdit}
        currentTemplate={currentTemplate}
      />

      <MessageDialog
        visible={messageVisible}
        title="Está seguro de eliminar esta plantilla?"
        message="Esta acción no se puede deshacer."
        onOk={deleteTemplate}
        onCancel={() => setMessageVisible(false)}
        confirm={true}
      />
    </div>
  );
};

export default TemplateTable;
